// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { PropertyError } from '../../../types/validation-result'

export const REGISTRATION_STATUS_NOT_REGISTRERED = 'REGISTRATION_STATUS_NOT_REGISTRERED'
export const REGISTRATION_STATUS_SUCCESS = 'REGISTRATION_STATUS_SUCCESS'
export const REGISTRATION_STATUS_ERROR = 'REGISTRATION_STATUS_ERROR'

export type RegistrationStatus =
  'REGISTRATION_STATUS_NOT_REGISTRERED'
  | 'REGISTRATION_STATUS_SUCCESS'
  | 'REGISTRATION_STATUS_ERROR'

export type RegistrationState = {
  emailAddress: string,
  status: RegistrationStatus,
  registrationValidationErrors: PropertyError[],
}
const state: RegistrationState = {
  emailAddress: '',
  status: REGISTRATION_STATUS_NOT_REGISTRERED,
  registrationValidationErrors: []
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/index.js